import { sectionTypes } from '../../constants/fields';
import { padOrTruncateArray } from '../utils';
import reversePointsAndRows from './reversePointsAndRows';
import generateRowPoints, { GENERATE_ROWS_INPUTS } from './generateRowPoints';
import generatePolygonPointsAndRows, {
  GENERATE_POLY_INPUTS,
} from './generatePolygonPointsAndRows';
import generateLinePointsAndRows, {
  GENERATE_LINE_INPUTS,
} from './generateLinePointsAndRows';
import generateKeyLinePointsAndRows, {
  GENERATE_KEY_LINE_INPUTS,
} from './generateKeyLinePointsAndRows';

export const uploadGeodataInputsMap = {
  [sectionTypes.GRID]: GENERATE_POLY_INPUTS,
  [sectionTypes.LINE]: GENERATE_LINE_INPUTS,
  [sectionTypes.KEYLINE]: GENERATE_KEY_LINE_INPUTS,
  [sectionTypes.IMPORTED]: GENERATE_ROWS_INPUTS,
};

const generatePointsAndRows = (input, dataMaps) => {
  const section = { ...input };

  // Since we're reversing the order of the points and rows *after* we generate
  // them, the row overrides need to get reversed beforehand.
  if (section.rowOrderIsReversed && section.rows?.features) {
    const rowCount = section.rows.features.length;
    section.rowOverrides = padOrTruncateArray(
      section.rowOverrides,
      rowCount,
    ).reverse();
  }

  // Generate points & rows:
  const pointsAndRows =
    section.type === sectionTypes.GRID
      ? generatePolygonPointsAndRows(section, dataMaps)
      : section.type === sectionTypes.LINE
      ? generateLinePointsAndRows(section, dataMaps)
      : section.type === sectionTypes.KEYLINE
      ? generateKeyLinePointsAndRows(section, dataMaps)
      : generateRowPoints(section, dataMaps); // Imported

  // NOTE: currently, reversing the order of points and rows is not supported
  // for imported sections.
  if (section.type === sectionTypes.IMPORTED) {
    return pointsAndRows;
  }

  // If needed, reverse the orders:
  const { rowOrderIsReversed, orderWithinRowsIsReversed } = section;
  return reversePointsAndRows(pointsAndRows, {
    rowOrderIsReversed,
    orderWithinRowsIsReversed,
  });
};

export const addPointsAndRows = (section, dataMaps) => ({
  ...section,
  ...generatePointsAndRows(section, dataMaps),
});

export const testExports = { generatePointsAndRows };
